import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSuitability } from '@/features/auth/hooks';

interface SuitabilityGateProps {
  children: React.ReactNode;
}

/**
 * Gate que redireciona o investidor para o onboarding de suitability
 * quando ainda não completou ou o questionário expirou (renovação anual).
 *
 * Deve envolver o conteúdo protegido, dentro do TermsGate:
 *   TermsGate → SuitabilityGate → conteúdo
 *
 * Apenas investidores são bloqueados — outros roles passam direto.
 */
export const SuitabilityGate: React.FC<SuitabilityGateProps> = ({ children }) => {
  const { needsAssessment, checking } = useSuitability();
  const navigate = useNavigate();

  useEffect(() => {
    if (!checking && needsAssessment) {
      navigate('/onboarding?step=suitability', { replace: true });
    }
  }, [checking, needsAssessment, navigate]);

  // Enquanto verifica ou precisa de avaliação, renderiza normalmente (evita flash)
  // O redirect via useEffect cuidará do redirecionamento
  if (checking) {
    return <>{children}</>;
  }

  // Se precisa de avaliação, não renderiza nada — o redirect vai acontecer
  if (needsAssessment) {
    return null;
  }

  return <>{children}</>;
};
